<template>
  <header :class="{'big-nav': bigLogo}">
    <div>
      <div class="margin-small-screens"></div>
      <nav class="navbar navbar-expand-lg fixed-top navbar-light " :class="!bigLogo ? addShadow ? 'shrink shadow-sm': 'shrink' : ''"><!--:class="scrollTop ? 'large' : 'shadow-sm'"-->
        <div class="container-fluid width-max">
          
          <!-- logo -->
          <div class="navbar-brand">   
            <router-link :to="{ name: 'Home' }">
              <div style="position: relative;"><div class="logo-line-cover " :class="{'show': !bigLogo}"></div></div>
              <img class="logo" :class="bigLogo ? 'large' : ''" width="92"  height="134" src="@/assets/logo/logo_png8_frame_white.png" alt="logo"><!-- width:114, 120frame  height:188-->
            </router-link>
          </div>
          
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- end logo -->

          <div class="collapse navbar-collapse " :class="{'big' : bigLogo}" id="navbarNav">   

            <!-- normal header -->
                <ul class="navbar-nav ms-auto mb-lg-0 navbar-links-container">
                  <li class="select-list-item"><SelectCollapsable /></li>
                  <!-- links to sections on page -->
                  <li class="nav-item dropdown" v-if="showSectionLinks">
                    
                    <a  class="nav-link dropdown-toggle bg-color" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Om {{getArtnavn + ""}} 
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'beskrivelse')">Beskrivelse</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'fakta')">Fakta</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'levested')">Levested</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'foede')">Føde</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'bestandsudvikling')">Bestandsudvikling</span></li>
                      <li v-if="showForskning">
                          <span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'forskning')">Forskning</span>
                      </li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'beskyttelse')">Beskyttelse</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'galleri')">Galleri</span></li>
                      <li v-if="showYngleudbredelse">
                          <span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'yngleudbredelse')">Yngleudbredelse</span>
                      </li>
                      <li v-if="showVinterudbredelse">
                        <span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'vinterudbredelse')">Vinterudbredelse</span>
                      </li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'observationer')">Observationer</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'dofBanner')">Det gør DOF for {{getArtnavn}}</span></li>
                      <li><span class="dropdown-item" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'mere')">Mere om {{getArtnavn}}</span></li>
                    </ul>
                  </li>

                  <li class="nav-item bg-color"><a class="nav-link" href="https://minside.dof.dk/stoet-naturen/">Støt DOF</a></li>

                  <li class="nav-item bg-color"><div class="nav-link pointer" :data-bs-toggle="!isWideScreen ? 'collapse' : ''" data-bs-target="#navbarNav" @click="$emit('clickGotoRef', 'footer')">Kontakt</div></li>
                </ul>
            <!-- end normal header -->
          </div>
        </div>
      </nav>
    </div>
  </header>

</template>



<script>
import SelectCollapsable from '@/components/birdSelect/BirdSelect_Collapsable.vue';

export default {
    name: 'Nav',

    props: {
      artnavn: {type:String, default: null},
      showYngleudbredelse: Boolean,
      showVinterudbredelse: Boolean,
      showForskning: Boolean,

      showSectionLinks: {
        type: Boolean,
        default: true
      },
      admin: {
        type: Boolean,
        default: false
      }
    },

    components: {
      SelectCollapsable,
    },
    watch: {
      $windowWidth(width) {
        this.setIsWideScreen(width);
      }
    },
    data() {
      return {
        bigLogo: true,
        addShadow: false,
        isWideScreen: false,
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      this.setIsWideScreen(this.$windowWidth);
    },
    unmounted() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
        setIsWideScreen(width) {
            this.isWideScreen = width > 767; // Burger menu from 767px and down
        },
        handleLinkClick() {
            this.$emit('clickLink', 'galleri');
        },
        logout() {
            localStorage.removeItem('access_token')
            localStorage.removeItem('refresh_token')
            this.$router.push({ name: 'Login' })
        },

        // TODO: is scroll detection necessary?
        handleScroll(e) {
            
            if (e.target.documentElement.scrollTop > 140) {
              this.bigLogo = false;
              this.addShadow = true;             
            } else if (e.target.documentElement.scrollTop > 5) {
              // Not at top
              this.bigLogo = false;
              this.addShadow = false;
            } else {
              // At top
              this.bigLogo = true;
              this.addShadow = false;
            }
        },

    },
    computed: {
        getArtnavn: function(){
            return this.artnavn ? this.artnavn.toLowerCase() : 'arten';
        },
    }
}
</script>



<style scoped>
  .nav-item{
    /* text-transform: uppercase; */
    margin-left: 7px;
  }
  .logo-line-cover{
      position: absolute;
      top: 0;
      height: 8px;
      width: 92px;
      background-color: #fff;
      opacity: 0;
  }
  .logo-line-cover.show {
      background-color: #fff;
      opacity: 1;
      transition: opacity .3s .3s;
  }

  .bg-color {
    /*text-transform: uppercase;*/
    font-size: 1.1rem;
    font-weight: 700;
  }
  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }
  li:last-child .nav-link {
    padding-right: 0;

  }
  li span:hover{
    cursor: pointer;
  }
  .select-list-item{
    margin-top: auto;
    margin-bottom: auto;
  }
  .navbar {
    height: 50px;
    background: rgba(255,255,255,1);
    /* transition: 0.3s; */
    padding: 0 0;
    z-index: 15000;
  }

  .navbar-brand {
    padding: 0 0;
    margin-top: 0;
    height: 50px;
  }
  .logo {
    height: 134px;
    width: 92px;
    object-fit: scale-down; 
    transition: 0.4s; 
    object-position: 0 0px;
    margin-top: -89px;
  }
  .logo.large {
    margin-top: 84px;   
    margin-top: 0px;   
    transition: .4s 0s;
  }
  .pointer{
    cursor: pointer;
  }

  /* Background behind dropdown (burger menu) 
     Bootstrap navbar-expand-lg = 767px, navbar-expand-lg = 991px */
  @media screen and (max-width: 991px) { 
    .navbar-collapse{
      background-color: #fff;
      position: absolute;
      left:0;
      top: 50px;
      width: 100%;
      padding-left: 8%;     
      z-index: -1;
    }
      
    .big-nav .navbar-links-container{
      padding-top: 75px;
    }
    .navbar-links-container{
      padding-bottom: 0.5em;
    }

    .nav-item{
      margin-left: 0px;
    }
  }

  @media screen and (max-width: 450px) {
    .navbar {
      height: 134px;
    }      
    .navbar.shrink {
      height: 50px;
    } 
    .logo.large { 
      margin-top: -42px;   
      transition: .4s 0s;
    }
    .margin-small-screens{
      width: 100%;
      height: 85px;
    }

  }
</style>



